import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('AFFILATES SERVICE');

@Injectable({
  providedIn: 'root'
})
export class AffilatesService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'affiliates' como el nombre del recurso a la clase base
    super('affiliates');
    log.debug('Servicio de Filiales inicializado');
  }

}
